import request from '@/utils/request'
import QueryString from 'qs'

export function loginWithCard(data) {
  return request({
    url: '/api/authorize/loginWithCard',
    method: 'post',
    data: QueryString.stringify(data),
    showLoading: true,
  })
}

export function logout() {
  return request({
    url: '/api/authorize/logout',
    method: 'delete',
    showLoading: true,
  })
}

export function login(data) {
  return request({
    url: '/api/authorize/login',
    method: 'post',
    data: QueryString.stringify(data),
  })
}

export function getUserWithRoleByCardId(params) {
  return request({
    url: '/api/authorize/getUserWithRoleByCardId',
    method: 'get',
    params: params,
    showLoading: true,
  })
}

export function getInfo(token) {
  return request({
    url: '/vue-admin-template/user/info',
    method: 'get',
    params: { token }
  })
}

